import { ref, computed } from 'vue';
import {
    listNotifications,
    markRead as apiMarkRead,
    deleteNotifications as apiDeleteNotifications,
} from '@/api/notifications';
import {useRoute} from "vue-router";


export function useNotifications() {
    const route = useRoute();
    const notifications = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const message = ref('');
    const messageOk = ref(null);
    
    const page = ref( Number(route.query.page ?? 1) );
    const size = ref( Number(route.query.size ?? 5) );
    const totalPages = ref( Number(0) );
    const totalElements = ref( Number(0) );
    
    let pollTimer = null;
    
    function showOk(msg) {
        message.value = msg;
        messageOk.value = true;
    }
    
    function showErr(msg) {
        message.value = msg;
        messageOk.value = false;
    }
    
    async function load(pageArg = 1, sizeArg = 20, status="") {
        loading.value = true;
        error.value = null;
        try {
            const data = await listNotifications(pageArg, sizeArg, status);
            page.value = data.number + 1;
            size.value = data.size;
            totalPages.value = data.totalPages;
            totalElements.value = data.totalElements;
            notifications.value = data.content;
            showOk('Данные загружены');
        } catch (e) {
            error.value = e;
            showErr('Не удалось загрузить');
        } finally {
            loading.value = false;
        }
    }
    
    async function deleteNotificationById(id) {
        try {
            await apiDeleteNotifications(id);
            return true;
        } catch (e) {
            return false;
        }
    }
    
    async function markRead() {
        await apiMarkRead();
    }
    
    function startPolling(intervalMs = 30000) {
        if (pollTimer) return;
        load(1, 5, 'NEW');
        
        pollTimer = setInterval(() => {
            load(1, 5, 'NEW');
        }, intervalMs);
    }
    
    function stopPolling() {
        if (pollTimer) {
            clearInterval(pollTimer);
            pollTimer = null;
        }
    }
    
    return {
        notifications,
        loading,
        error,
        message,
        messageOk,
        page,
        size,
        totalPages,
        totalElements,
        startPolling,
        stopPolling,
        deleteNotificationById,
        load,
        markRead,
    };
}
